import { useEffect, useState } from 'react';
import { useDispatch,useSelector} from "react-redux";
import { set_Acc_InProgress, unset_updatemeeting,set_showmeeting} from '../slice/mainslice'
import { Button, Space, Group,Text, Paper,Modal,Grid,Notification, Alert, Switch} from '@mantine/core';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import { AlertTriangle, Check } from 'tabler-icons-react';
import { DatesProvider, TimeInput , DatePickerInput } from '@mantine/dates';
import intl from 'react-intl-universal';

dayjs.extend(utc);
dayjs.extend(timezone);

const EndMeeting = (props:any) => {
    const dispatch = useDispatch()
    const meetinginfo = useSelector((state: any) => state.user.meetinginfo)
    const updatemeetingdate = useSelector((state: any) => state.user.updatemeetingdate)
    const showlogs = useSelector((state: any) => state.user.showlogs)

    const [showbuttons, setShowbuttons] = useState(true);

    const [logoutopened, setLogoutopened] = useState(false);

    const [date, onChange] = useState<any>();
    const [von, onChangeTimeStart] = useState<any>();
    const [bis, onChangeTimeEnd] = useState<any>();
    const [timeerror, setTimeerror] = useState(false);
    const [timeerror1, setTimeerror1] = useState(false);
    const [timeerrorend, setTimeerrorend] = useState(false);
    const [timeerrorend1, setTimeerrorend1] = useState(false);
    const [disablebutton, setDisablebutton] = useState(true);

    const [savedocs, setSavedocs] = useState(true);

    const offsetMinutes = new Date().getTimezoneOffset();
    const offsetHours = Math.abs(offsetMinutes) / 60;
    const offsetSign = offsetMinutes < 0 ? '+' : '-';
    const formattedOffset = `${offsetSign}${String(offsetHours)}`;

    const [calendardate, setCalendardate] = useState(new Date());
    const [calendarlang, setCalendarlang] = useState("");
    const defvalue = useSelector((state: any) => state.user.clientlanguage)

    const [havedate, setHaveDate] = useState(false);
    const [fielderror, setFielderror] = useState(false);

 //let teststart:any
 //let testend:any

 //teststart = "2024-08-19T12:00:00+00:00"
 //testend = "2024-08-19T13:00:00+00:00"

 //console.log(teststart)
 //console.log(testend)

    useEffect(() => {
      // Get the current date
      const currentDate = new Date();

      // Compare the dates
      // Wenn das aktuelle Datum kleiner als das Startdatum ist, wird das Startdatum verwendet
      //console.log(meetinginfo.datStart)
      //console.log(meetinginfo.datEnd)


      // Ansonsten das aktuelle Datum
      if (currentDate < new Date(meetinginfo.datStart)) {
        setCalendardate(new Date(meetinginfo.datStart));
      } else {
        setCalendardate(currentDate);
      }
/*
      if (currentDate < new Date(teststart)) {
        setCalendardate(new Date(teststart));
      } else {
        setCalendardate(currentDate);
      }
*/

      if (date) {
        setHaveDate(true)
      } else {
        setHaveDate(false)
      }

      

      // Passe die KAlendersprache an
      if (defvalue === "de_DE") {
        setCalendarlang("de");
      } else if (defvalue === "en_US") {
        setCalendarlang("en");
      }

    }, [meetinginfo,defvalue,date]);


    const handleLogout = () => {
      setLogoutopened(true);
    };

    const handleLogoutclose = () => {
      setLogoutopened(false);
    };
  

    const handleLogoutYesClick = () => {
      sentlogoutcommand();
      handleLogoutclose();
    };
  
    const handleLogoutNoClick = () => {
      handleLogoutclose();
    };   

    const sentlogoutcommand = () => {

     /* if (savedocs){ */
        const sentzippayload = {
          drnId: meetinginfo.drnId,
          timezone: formattedOffset,
        }; 

        dispatch({ type: 'SIGNALR_SENDCLOSEMEETING_ZIPARCHIV', payload: sentzippayload });
    /*}*/ 

      const handlelogoutpayload = {
        drnId: meetinginfo.drnId,
        command: "closevideopopup"   
      }; 
      
      dispatch({ type: 'SIGNALR_SENDCLOSEMEETING', payload: handlelogoutpayload });

    }

    
    const closemessage = () => {
      dispatch(unset_updatemeeting())
      onChange(undefined);
     
    }
    
    const swichtbuttons = () => {
        if (showbuttons === true ){
            setShowbuttons(false)
            dispatch(set_Acc_InProgress("Verabschiedung"))
            
        }
        if (showbuttons === false ){
            setShowbuttons(true)
            dispatch(set_Acc_InProgress(""))
        }
    }


    const handleStartTimeChange = (value: any) => {
      onChangeTimeStart(value);
      if (bis) {
         isValidTime(value, bis); // Run validation with both start and end times
      }
    };
  
    const handleEndTimeChange = (value: any) => {
      onChangeTimeEnd(value);
      if (von) {
       isValidTime(von, value); // Run validation with both start and end times
      }
    };

    const isValidTime = (von: any, bis: any) => {
      setTimeerror(false);
      setTimeerror1(false);
      setTimeerrorend(false);
      setDisablebutton(true);

      const meetingStart = new Date(meetinginfo.datStart);
      //const meetingEnd = new Date(meetinginfo.datEnd);
      

      let newdate = dayjs(date).format('YYYY-MM-DD')
 
      const [yyyy, mm, dd] = newdate.split('-').map(Number);
      const [vonhours, vonminutes] = von.target.value.split(':').map(Number);
      const [bishours, bisminutes] = bis.target.value.split(':').map(Number);

      //console.log(yyyy, mm, dd)

      const userStart = new Date(yyyy, mm-1, dd, vonhours, vonminutes);
      const userEnd = new Date(yyyy, mm-1, dd, bishours, bisminutes);

      //console.log(meetingStart)
      //console.log(meetingEnd)
      //console.log(userStart)
      //console.log(userEnd)

        // Validation checks
        if (userEnd.getTime() < userStart.getTime()) {
          //console.log("Die Beginnzeit muss vor dem Terminende liegen");
          setTimeerror(true);
          setFielderror(true);
          return false;
        }

        if (userStart.getTime() < meetingStart.getTime()) {
          //console.log("User end time must be before the meeting end time.");
          setTimeerror1(true);
          setFielderror(true);
          return false;
        }

        // Check if there are at least 15 minutes between userStart and userEnd
        const timeDifference = userEnd.getTime() - userStart.getTime();
        const minDifference = 15 * 60 * 1000; // 15 minutes in milliseconds

        if (timeDifference < minDifference) {
            //console.log("The time difference between start and end must be at least 15 minutes.");
            setTimeerrorend(true);
            setFielderror(true);
            return false;
        }

        //console.log("Valid times.");
        setDisablebutton(false)
        setFielderror(false);
        return true; 
    }


    /*const isSecondTimeGreaterThanFirst = (time1: string, time2: string): boolean => {
      // Zerlege die Zeitzeichenfolgen in Stunden und Minuten
      const [hours1, minutes1] = time1.split(':').map(Number);
      const [hours2, minutes2] = time2.split(':').map(Number);
      console.log(hours1, minutes1, hours2, minutes2)
      // Erstelle Date-Objekte für beide Zeiten
      const date1 = new Date(0, 0, 0, hours1, minutes1);
      const date2 = new Date(0, 0, 0, hours2, minutes2);
      return date2.getTime() < date1.getTime();
    };
*/
/*
    const isNewTimeisgreater = (newtime: string): boolean => {
      let newdate = dayjs(date).format('YYYY-MM-DD')
      let newdatevon = newdate+"T"+newtime+":00.000Z"
      //newdatevon = dayjs(newdatevon).subtract(1, 'hour').toISOString();
      //return new Date(newdatevon) <= new Date(testend) 
     return new Date(newdatevon) <= new Date(meetinginfo.datStart) 
    }
*/

/*    const isNewTimeisgreaterEnd = (newtime: string): boolean => {
      let newdate = dayjs(date).format('YYYY-MM-DD')
      let newdatevon = newdate+"T"+newtime+":00.000Z"
      //newdatevon = dayjs(newdatevon).subtract(1, 'hour').toISOString();
      //return new Date(newdatevon) <= new Date(testend) 
      return new Date(newdatevon) <= new Date(meetinginfo.datEnd) 
    }
      */
/*
    let filedvonerror1 = false
    const validatetime1 = (value: any) => {
      console.log("validatetime1")
      if (von !== undefined) {
      const checktime = isSecondTimeGreaterThanFirst(von.target.value, value.target.value)
          if(checktime){
            setTimeerror(true)
            filedvonerror1 = true
          } else {
            setTimeerror(false)
          }
        const checktimenew = isNewTimeisgreater(value.target.value)
            if (checktimenew){
              setTimeerror1(true)
            } else {
              setTimeerror1(false)
            }
        } 
       // onChangeTime1(value)
     }



     let filedvonerror = false
     const validatetime = (value: any) => {
      console.log("validatetime")
      if (bis !== undefined) {
      const checktime = isSecondTimeGreaterThanFirst(value.target.value, bis.target.value)
          if(checktime){
            setTimeerrorend(true)
            filedvonerror = true
                
          } else {
            setTimeerrorend(false)
              
          }

          const checktimenew = isNewTimeisgreater(value.target.value)
            if (checktimenew){
              console.log("Hit validatetime1")
              setTimeerrorend1(true)
            } else {
              setTimeerrorend1(false)
            }
        
        } else if (value.target.value !== undefined) {
          const checktimenew = isNewTimeisgreater(value.target.value)
            if (checktimenew){
              setTimeerrorend1(true)
            } else {
              setTimeerrorend1(false)
            }
        }
        //onChangeTime(value)
     }

*/


    const sendvertagung = () => {


      /*let newdatevon = newdate+"T"+von.target.value+":00.000Z"
      let newdatebis = newdate+"T"+bis.target.value+":00.000Z"*/
      let newDate = dayjs(date).format('YYYY-MM-DD')

      // Get time parts from input elements
      const vonHour = parseInt(von.target.value.split(':')[0], 10);
      const vonMinute = parseInt(von.target.value.split(':')[1], 10);
      const bisHour = parseInt(bis.target.value.split(':')[0], 10);
      const bisMinute = parseInt(bis.target.value.split(':')[1], 10);
      
      // Create dayjs objects in the user's local timezone
      let newDateVon = dayjs(newDate) 
        .set('hour', vonHour)
        .set('minute', vonMinute)
        .tz('Europe/Berlin') // Set the user's timezone
        .format('YYYY-MM-DDTHH:mm') + generateTimezoneOffset(); // Format and append timezone offset
      
      let newDateBis = dayjs(newDate)
        .set('hour', bisHour)
        .set('minute', bisMinute)
        .tz('Europe/Berlin')
        .format('YYYY-MM-DDTHH:mm') + generateTimezoneOffset(); 
      
      // Helper function to generate timezone offset string
      function generateTimezoneOffset() {
        const offset = new Date().getTimezoneOffset() / 60; // Offset in hours
        const sign = offset < 0 ? '+' : '-';
        const offsetHours = Math.abs(offset).toString().padStart(2, '0'); // Ensure 2 digits
        return `${sign}${offsetHours}`;
      }

      const newtermpayload = {
        vcId: meetinginfo.drnId,
        startDate:newDateVon,
        endDate:newDateBis
       
      };

      //console.log(newtermpayload)

      dispatch({ type: 'SIGNALR_UDATE_MEETINGDATE', payload: newtermpayload });
      swichtbuttons()
    }

    let viewnewdate
    
    //let disable = true
    //console.log(timeerror,timeerror1, timeerrorend, timeerrorend1)
    if (von !== undefined && bis !== undefined && date !== undefined && timeerror === false && timeerror1 === false && timeerrorend === false && timeerrorend1 === false) {
     viewnewdate = dayjs(date).format('DD-MM-YYYY') + " " + von.target.value +" - "+ bis.target.value
     //disable = false
     }


     const sendgetlogdata = () => {

      const logatapayload = {
        drnId: meetinginfo.drnId,
      };

    dispatch({ type: 'SIGNALR_GET_MEETINGLOG', payload: logatapayload }); 
    dispatch(set_showmeeting());
     }

     const closelogdata = () => {
      dispatch(set_showmeeting());
     }



  return (
    <>
    {showbuttons &&
    <>      
        <Space h="xl" />  
        {!showlogs &&
        <Button fullWidth color="green" onClick={()=>sendgetlogdata()}>{intl.get('ENDMEETING_BUTTON_VIEW')}</Button>
        }
        {showlogs &&
          <Button fullWidth color="gray" onClick={()=>closelogdata()}>{intl.get('ENDMEETING_BUTTON_CLOSE')}</Button>
        }
        <Space h="xl" />
        {!updatemeetingdate &&
        <Button fullWidth color="gray" onClick={()=>swichtbuttons()}>{intl.get('ENDMEETING_BUTTON_NEWTERM')}</Button>
        }
        {updatemeetingdate &&
          <Notification onClose={()=>closemessage()} icon={<Check size="1.1rem" />} color="teal" title={intl.get('ENDMEETING_NOTE_NEWTERM_HEAD')}>
            {intl.get('ENDMEETING_NOTE_NEWTERM_TEXT')}
          </Notification>
        }       
        <Space h="xl" />
        <Button fullWidth color="red" onClick={()=>handleLogout()}>{intl.get('ENDMEETING_BUTTON_END')}</Button>
    </>
    }

{!showbuttons &&
    <>
     <Paper shadow="xs" p="md">
    <Text>{intl.get('ENDMEETING_NEWTERM_TEXT')}</Text>
    <hr />
        <DatesProvider settings={{ locale: calendarlang, firstDayOfWeek: 0, weekendDays: [0] }}>
            <DatePickerInput 
               mt="md" 
               label={intl.get('ENDMEETING_NEWTERM_DATE')}
               onChange={onChange} 
               minDate={new Date(calendardate)}
               firstDayOfWeek={1}
               />
            <Group>
            {havedate && 
            <>
            <TimeInput 
                 label={intl.get('ENDMEETING_NEWTERM_TIME_FROM')} 
                 withAsterisk 
                 onChange={handleStartTimeChange}
                 error={fielderror}
                 
                 />
            <TimeInput 
                label={intl.get('ENDMEETING_NEWTERM_TIME_TO')}  
                 withAsterisk
                 onChange={handleEndTimeChange} 
                 error={fielderror}
                />
                </>
              } 
            {timeerror &&
             <Alert  icon={<AlertTriangle size="1rem" />} title={intl.get('TERM_ERROR_HEAD')} color="red"  >
               <span>{intl.get('TERM_ERROR_TEXT')}</span>
            </Alert>
            }
            {timeerror1 &&
             <Alert  icon={<AlertTriangle size="1rem" />} title={intl.get('TERM_ERROR_HEAD')} color="red"  >
               <span>{intl.get('TERM1_ERROR_TEXT')}</span>
            </Alert>
            }
            {timeerrorend &&
             <Alert  icon={<AlertTriangle size="1rem" />} title={intl.get('TERM_ERROR_HEAD')} color="red"  >
               <span>{intl.get('TERM2_ERROR_TEXT')}</span>
            </Alert>
            }
            {timeerrorend1 &&
             <Alert  icon={<AlertTriangle size="1rem" />} title={intl.get('TERM_ERROR_HEAD')} color="red"  >
               <span>{intl.get('TERM1_ERROR_TEXT')}</span>
            </Alert>
            }

            {viewnewdate !== undefined &&
                <div>{viewnewdate}</div>
            }
            </Group>
            <Space h="xs" />
            <Group>
        <Button 
          fullWidth 
          color="green"
          disabled={disablebutton}
          onClick={()=>sendvertagung()}
          >{intl.get('ENDMEETING_NEWTERM_BUTTON_YES')}</Button>
        <Button 
          fullWidth 
          color="red"
          onClick={()=>swichtbuttons()}
          >{intl.get('ENDMEETING_NEWTERM_BUTTON_NO')}</Button>
        </Group>          
        </DatesProvider>
        </Paper>
    </>
    }


    <Modal
        title=""
        opened={logoutopened}
        onClose={handleLogout}
        closeOnClickOutside={false}
        withCloseButton={false}
        size="md"
        shadow="sm"
        centered
        zIndex={10000}
        >
          <Text>{intl.get('ENDMEETING_MODAL_TEXT')}</Text>
          {/*
          <Alert  color="gray">
            <Switch size="md" color="green" label="Ablage des Protokollpakets" onLabel="Ja" offLabel="Nein"   checked={savedocs}  onChange={() => setSavedocs(!savedocs)} /> 
         </Alert>
         */}
          <hr />
          <Grid>
          <Grid.Col span={6}>
            <Button fullWidth color="green" onClick={handleLogoutYesClick}>{intl.get('DIALOG_BUTTON_YES')}</Button>
            </Grid.Col>
            <Grid.Col span={6}>
            <Button fullWidth color="gray" variant="light" onClick={handleLogoutNoClick}>{intl.get('DIALOG_BUTTON_NO')}</Button>
            </Grid.Col>
          </Grid>
      </Modal>


   </>
  );
}

export default EndMeeting;